/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_SubtitleInputs */

const en_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AutoCAD-style drafting app from ArtCraft, rebuilt in pure Rust. Use it online now or download it free.`)
};

/**
* | output |
* | --- |
* | "The AutoCAD-style drafting app from ArtCraft, rebuilt in pure Rust. Use it online now or download it free." |
*
* @param {Home_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_hero_subtitle = /** @type {((inputs?: Home_Hero_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_hero_subtitle(inputs)
});
export { home_hero_subtitle as "home.hero.subtitle" }